import { createAction, props } from '@ngrx/store';
import { ScraperProgressStatus } from './scraper-progress-status.enum';
import { ScraperProgress } from './scraper-progress.reducer';

export const updateProgress = createAction(
  '[Scraper Progress Component] Update progress',
  props<{ scraperProgress: ScraperProgress; studyId: number }>()
);

export const updateStatus = createAction('[Scraper Progress Component] Update status', props<{ status: ScraperProgressStatus; studyId: number }>());
